import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import supabase from './supabase';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    orders: [],
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },

    setOrders(state, payload) {
      state.orders = payload;
    },
  },
  actions: {
    async getCurrentUser({ commit }) {
      commit('setUser', await supabase.auth.user());
    },

    async getOrders({ state, commit }) {
      const shipments = await supabase
        .from('shipments')
        .select();

      let orders;

      if (state.user.app_metadata.role === 'staff') {
        orders = await supabase
          .from('orders')
          .filter('status', 'eq', 'open')
          .select('id, contents');
      } else if (state.user.app_metadata.role === 'vendor') {
        orders = await supabase
          .from('orders')
          .filter('status', 'eq', 'open')
          .filter('vendor_id', 'eq', state.user.app_metadata.vendor_id)
          .select('id, contents');
      }

      orders.body.forEach((order) => {
        let statusCount = 0;
        order.status = 'green';

        order.contents.forEach((item) => {
          let itemStatusCount = 0;
          item.status = 'green';
          item.shipments = [];
          item.available = item.qty;
          item.shipped = 0;

          shipments.body.forEach((shipment) => {
            if (item.id === shipment.item_id) {
              item.available -= shipment.qty;
              item.shipments.push(shipment);

              if (shipment.ship_method) {
                item.shipped += shipment.qty;
              }

              if (moment(item.scheduled_ship_date).isBefore(shipment.ship_date, 'day')) {
                statusCount += 1;
                itemStatusCount += 1;
              }
            }
          });

          if (item.available > 0) {
            statusCount += 1;
            itemStatusCount += 1;
          }

          if (itemStatusCount > 0) {
            item.status = 'red';
          }
        });

        if (statusCount > 0) {
          order.status = 'red';
        }
      });

      commit('setOrders', orders ? orders.body : []);
    },
  },
  modules: {},
});
